export const TENANT_FUNCTIONS_RESET_STATE = 'TENANT_FUNCTIONS_RESET_STATE';
export const TENANT_FUNCTIONS_CURRENT_ITEM = 'TENANT_FUNCTIONS_CURRENT_ITEM';

export const TENANT_FUNCTIONS_REQUEST_LOADING = 'TENANT_FUNCTIONS_REQUEST_LOADING';
export const TENANT_FUNCTIONS_REQUEST_SUCCESS = 'TENANT_FUNCTIONS_REQUEST_SUCCESS';
export const TENANT_FUNCTIONS_REQUEST_FAILED = 'TENANT_FUNCTIONS_REQUEST_FAILED';

export const TENANT_FUNCTIONS_CURRENT_ACTION = 'TENANT_FUNCTIONS_CURRENT_ACTION';
export const TENANT_FUNCTIONS_RESET_ACTION = 'TENANT_FUNCTIONS_RESET_ACTION';